import { MaintenanceLevelsActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    master_data: [],
    maintenanceLevelsList: null,
    maintenanceLevelsListDetails: null,
    deleted_maintenanceLevelsList: null,
    saved_maintenanceLevelsList: null,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case MaintenanceLevelsActionTypes.get_maintenanceLevelsList.REQUEST:
            return {
                ...state,
                loading: true,
                maintenanceLevelsList: null
            };
        case MaintenanceLevelsActionTypes.get_maintenanceLevelsList.SUCCESS:
            return {
                ...state,
                loading: false,
                maintenanceLevelsList: payload
            };
        case MaintenanceLevelsActionTypes.get_maintenanceLevelsDetails.REQUEST:
            return {
                ...state,
                loading: true,
                maintenanceLevelsListDetails: null
            };
        case MaintenanceLevelsActionTypes.get_maintenanceLevelsDetails.SUCCESS:
            return {
                ...state,
                loading: false,
                maintenanceLevelsListDetails: payload
            };
        case MaintenanceLevelsActionTypes.post_maintenanceLevels.REQUEST:
            return {
                ...state,
                loading: true,
                saved_maintenanceLevelsList: null
            };
        case MaintenanceLevelsActionTypes.post_maintenanceLevels.SUCCESS:
            return {
                ...state,
                loading: false,
                saved_maintenanceLevelsList: payload
            };
            case MaintenanceLevelsActionTypes.delete_maintenanceLevels.REQUEST:
            return {
                ...state,
                loading: true,
                deleted_maintenanceLevelsList: null
            };
        case MaintenanceLevelsActionTypes.delete_maintenanceLevels.SUCCESS:
            return {
                ...state,
                loading: false,
                deleted_maintenanceLevelsList: payload
            };
        case MaintenanceLevelsActionTypes.get_master_data.REQUEST:
            return {
                ...state,
                loading: true,
                master_data: null,
            };
        case MaintenanceLevelsActionTypes.get_master_data.SUCCESS:
            return {
                ...state,
                loading: false,
                master_data: payload,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/maintenanceLevel/reducers/maintenanceLevelsReducer.js